import cn from 'clsx'

const colors = [
    'bg-primary',
    'bg-primary-focus',
    'bg-primary-content',
    'bg-secondary',
    'bg-secondary-focus',
    'bg-secondary-content',
    'bg-accent',
    'bg-accent-focus',
    'bg-accent-content',
    'bg-neutral',
    'bg-neutral-focus',
    'bg-neutral-content',
    'bg-base-100',
    'bg-base-200',
    'bg-base-300',
    'bg-base-content',
    'bg-info',
    'bg-info-content',
    'bg-success',
    'bg-success-content',
    'bg-warning',
    'bg-warning-content',
    'bg-error',
    'bg-error-content',
]

const KSColorsView = ({
    className,
    useWhiteBg,
}) => {
    
    return (
        
        <ul className={cn(className, {
            'text-gray-800 bg-white': useWhiteBg,
        })}>
            {colors.map(it => (
                <li key={it} className="flex items-center gap-3 px-3 py-1">
                    <div className={cn('w-4 h-4 rounded-full', it)} />
                    <div>{it.substring(3)}</div>
                </li>
            ))}
        </ul>
        
    )
    
}

export default KSColorsView
